//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: '',
    props: {
        routes: {
            type: Array,
            default() {
                return []
            }
        },
        isNew: {
            type: Boolean,
            default: false
        }
    }
}
